import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';

import css from '../../OnlineTeachersForHirePage.module.css';

const IconCard = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg className={classes} width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_171_27302)">
        <path d="M25.2384 0L29.6289 8.02766L37.6566 12.4181L29.6289 16.8086L25.2384 24.8363L20.848 16.8086L12.8203 12.4181L20.848 8.02766L25.2384 0Z" fill="#F5E12E"/>
        <path d="M54.7619 0L59.1523 8.02766L67.18 12.4181L59.1523 16.8086L54.7619 24.8363L50.3714 16.8086L42.3438 12.4181L50.3714 8.02766L54.7619 0Z" fill="#FBC009"/>
        <path d="M30.2484 70.922L25.4205 80.0002H14.4256V73.9153L0 51.2969V13.8203H2.835C7.05906 13.8203 10.4833 17.2702 10.4833 21.5252V43.8456L30.2484 70.922Z" fill="#C27B44"/>
        <path d="M36.3202 63.2031V80.0001H25.4209V69.7024L10.8981 46.5571C9.55602 44.1245 10.4035 41.0126 12.7535 39.5989C15.2452 38.1009 18.4735 38.9776 19.8788 41.5345L26.7323 53.9968C31.8343 53.9921 36.3202 57.8687 36.3202 63.2031Z" fill="#D58854"/>
        <path d="M49.6113 70.922L54.4616 80.0002H65.5074V73.9153L79.9996 51.2969V13.8203H77.1516C72.908 13.8203 69.4679 17.2702 69.4679 21.5252V43.8456L49.6113 70.922Z" fill="#AC7042"/>
        <path d="M43.5117 63.2031V80.0001H54.4614V70.0215L69.0513 46.5571C70.3994 44.1245 69.5481 41.0126 67.1872 39.5989C64.6841 38.1009 61.4406 38.9776 60.0289 41.5345L53.1439 53.9968C48.0184 53.9921 43.5117 57.8687 43.5117 63.2031Z" fill="#C27B44"/>
        <path d="M44.3905 30.9832L40.0001 22.9556L37.3105 35.3737L40.0001 47.7917L44.3905 39.7642L52.4182 35.3737L44.3905 30.9832Z" fill="#FBC009"/>
        <path d="M35.6097 30.9832L27.582 35.3737L35.6097 39.7642L40.0002 47.7917V22.9556L35.6097 30.9832Z" fill="#F5E12E"/>
      </g>
      <defs>
        <clipPath id="clip0_171_27302">
          <rect width="80" height="80" fill="white"/>
        </clipPath>
      </defs>
    </svg>

  );
};

IconCard.defaultProps = {
  className: null,
  rootClassName: null,
};

IconCard.propTypes = {
  className: string,
  rootClassName: string,
};

export default IconCard;
